import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import './ThemeToggle.css';

/**
 * Theme toggle button for switching between light and dark modes.
 * Displays a sun icon in dark mode (click to switch to light)
 * and a moon icon in light mode (click to switch to dark).
 */
function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <div className="theme-toggle-track">
        <div className={`theme-toggle-thumb ${isDark ? 'dark' : 'light'}`}>
          {isDark ? (
            <Sun size={14} className="theme-icon" />
          ) : (
            <Moon size={14} className="theme-icon" />
          )}
        </div>
      </div>
    </button>
  );
}

export default ThemeToggle;
